$(document).ready(function() {
  $('.validation_form_thankyou_content').hide();
  $('#validation_form_submit').click(function(e) {
    console.log("validation_form_submit clicked");
    e.preventDefault();
    var mobileNo = $("#validation_form_number").val().trim();
    const mobileNoRegex = /^[6-9][0-9]{9}$/;
    $(".error_msg").text("");
    $(".mobile_no_error_msg").text("");
    if (mobileNo === '') {
      $(".error_msg").text("Fields marked with an asterisk are required.");
      return;
    }
    if (!mobileNoRegex.test(mobileNo)) {
      $(".mobile_no_error_msg").text("Please enter a valid 10-digit mobile number.");
      return;
    }
    var url = `https://hul-services.enscommerce.in/liquidiv/user/validate-phone-number?phone=${mobileNo}`;
    $.ajax({
      type: "GET",
      url: url,
      contentType: 'application/json',
      dataType: 'json',
      success: function(response) {
        $("#validation_form_wrapper").hide();
        if (response.success && response.valid) {
          $(".newsletter__subheading").hide();
          $(".validation_form_wrapper").hide();
          $('.validation_form_thankyou_content').show();
        } else {
          $(".newsletter__subheading").hide();
          $(".validation_form_wrapper").hide();
          $('.validation_form_error_content').show();;
        }
        // Reset form after 5 seconds
        setTimeout(function() {
          $(".newsletter__subheading").show();
          $(".validation_form_wrapper").show();
          $("#validation_form_number").val("");
          $('.validation_form_thankyou_content').hide();
          $('.validation_form_error_content').hide();
        }, 8000);
      },
      error: function(error) {
        console.log("validate-phone-number API error", error);
        $('#error_msg').text("Something went wrong. Please try again later.");
      }
    });
  });
});